export const GET_DOCUMENTS = '/api/document/getall';
export const GET_DOCUMENT_BY_ID = '/api/document/getbyid';
export const UPDATE_DOCUMENT = '/api/document/update';
export const CREATE_DOCUMENT = '/api/document/create';
export const DELETE_DOCUMENT = '/api/document/remove';
